<template>
  <div class="edit">
    <h3>我的就诊人</h3>
    <div class="info">
      <el-form :model="info" ref="info" :rules="rules" label-width="320px" class="demo-ruleForm">
        <p class="base">基本信息</p>
        <el-form-item
                label="就诊人姓名："
                prop="name"
        >
          <el-input type="text" v-model.number="info.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别：" prop="sex">
          <el-radio-group v-model="info.sex">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
                label="就诊人手机号："
                prop="mobile"
        >
          <el-input type="age" v-model="info.mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
                label="就诊人身份证号："
                prop="idCard"
        >
          <el-input type="text" v-model="info.idCard" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
                label="就医账号："
                prop="jiuyiNo"
        >
          <el-input type="text" v-model="info.jiuyiNo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="选择医院：" prop="hospitalId">
          <el-select v-model="info.hospitalId"  placeholder="请选择">
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in hospital" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
                label="填写就诊医院条码，病案号，一卡通号，门诊号："
                prop="barCodes"
                v-for="(item, index) in info.barCodes"
                :key="item.id"
        >
          <el-input type="text" v-model="item.barcode" autocomplete="off" placeholder="就诊医院条码，病案号，一卡通号，门诊号（选填）"   ></el-input>
<!--          <span class="handle" @click="add">添加</span>-->
<!--          <span class="handle" @click="del(index)">删除</span>-->
        </el-form-item>
<!--        <p class="base">就诊医院条码，病案号，一卡通号</p>-->
        <el-form-item>
          <el-button type="primary" @click="submitForm('info')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {reqPatientChange, reqHospital, reqPatientInfo} from '../../../api'
import {mobiles, idCard} from '../../../utils/phone'
export default {
  data() {
    let validPhone = (rule, value, callback) => {
      if(!mobiles(value)){
        callback(new Error('手机号码不正确'))
      }else{
        callback()
      }
    }
    let validCard = (rule, value, callback) => {
      if(!idCard(value)){
        callback(new Error('身份证不正确'))
      }else{
        callback()
      }
    }
    let validateListNotEmpty = (rule, value, callback) => {
      value.forEach((item, index) => {
        if (item.barcode=='') {
          callback(new Error('医院不能为空'));
        } else {
          callback();
        }
      })
      
    };
    return {
      info: {
        name: '', // 姓名
        sex: '', // 性别
        mobile: '', // 手机号
        idCard: '', // 身份证
        hospitalIds: [], // 医院
        hospitalId: '',
        jiuyiNo: '', // 账号信息
        barCodes: [{barcode: ''}] // 填写卡号
      },
      hospital: [],
      rules: {
        name: [{required: true, message: '请输入就诊人姓名', trigger: 'blur'}],
        sex: [{required: true, message: '请选择就诊人性别', trigger: 'blur'}],
        mobile: [{required: true, message: '请输入就诊人手机号', trigger: 'blur'}, {validator: validPhone, trigger: 'blur'}],
        idCard: [{required: true, message: '请输入就诊人身份证号', trigger: 'blur'}, {validator: validCard, trigger: 'blur'}],
        jiuyiNo: [{required: true, message: '请输入就医账号', trigger: 'blur'}],
        hospitalId: [{required: true, message: '请选择医院', trigger: 'blur'}],
        barCodes: [{required: true, message: '请填写卡号', trigger: 'blur'},{validator: validateListNotEmpty, trigger: 'blur'}]
      }
    };
  },
  created() {
    // 获取医院列表
    reqHospital({pageSize:9999}).then(res => {
      if(res.code === 200) {
        this.hospital = res.data.bussData
      }
    })
    if (this.$route.query.id) {
      reqPatientInfo(this.$route.query.id).then(res => {
        if(res.code === 200){
          const {name, sex, mobile, idCard, jiuyiNo, patientSubDtos} = res.data.bussData
          patientSubDtos.forEach(item => {
            this.info.hospitalIds.push(item.hospitalId)
          })
          if(patientSubDtos.length > 0){
              this.info.hospitalId = patientSubDtos[0].hospitalId
            }
          this.info.sex = sex === '1' ? '男' : '女'
          this.info.name = name
          this.info.mobile = mobile
          this.info.idCard = idCard
          this.info.jiuyiNo = jiuyiNo
          if(patientSubDtos.length) {
            this.info.barCodes = patientSubDtos
          }
        }
      })
    }
  },
  methods: {
    removeTag(item) {
      this.hosIds = this.hosIds.filter(i => i != item)
    },
    // 添加
    add() {
      let cope = {
        barcode: "",
      }
      this.info.barCodes.push(cope);
    },
    // 删除
    del(index) {
      if(index == 0) return
      this.info.barCodes.splice(index, 1)
    },
    // 提交信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const {type, id} = this.$route.query
          let {name, sex, mobile, idCard, jiuyiNo, hospitalIds,hospitalId, barCodes} = this.info
          let hospitalStr = ''
          let barCodesStr = ''
          hospitalIds.push(hospitalId)
          hospitalIds.forEach((item, index) => {
            let regex = /[\u4E00-\u9FA5\uF900-\uFA2D]/
            if(!regex.test(item)) {
              if(index === hospitalIds.length-1){
                hospitalStr += item
              } else {
                hospitalStr += item + ','
              }
            }
          })
          barCodes.forEach((item, index) => {
            if(index === barCodes.length-1) {
              barCodesStr += item.barcode
            } else {
              barCodesStr += item.barcode + ','
            }
          })
          sex = sex === '男' ? '1' : '2'
          let info = {}
          if(id) {
            info = {
              id,
              name,
              sex,
              mobile,
              idCard,
              jiuyiNo,
              hospitalIds: hospitalStr,
              barCodes: barCodesStr
            }
          }else {
            info = {
              name,
              sex,
              mobile,
              idCard,
              jiuyiNo,
              hospitalIds: hospitalStr,
              barCodes: barCodesStr
            }
          }
          reqPatientChange(info).then(res => {
            console.log(res)
            if(res.code === 200) {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.$router.replace('/person/patient')
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style scoped lang="less" type="text/less">
  .edit{
    h3{
      margin-top:60px;
      font-size: 24px;
    }
    .info{
      .base{
        margin:30px 0;
        font-size: 16px;
        font-weight: bold;
      }
      .handle{
        display: inline-block;
        width: 80px;
        height: 40px;
        margin-left: 30px;
        text-align: center;
        line-height: 40px;
        border:1px solid #999;
        border-radius: 20px;
        font-size: 16px;
        box-sizing: border-box;
        cursor: pointer;
      }
    }
  }
  .el-input{
    width: 306px;
  }
  .el-button--primary{
    width: 306px;
    height: 48px;
    box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
    border-radius:24px;
    background: #61aee6;
    border-color:#61aee6;
    box-sizing: border-box;
  }
  .el-select{
    width: 306px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/EditPatient.vue